var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlockquote(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M20.67 20.13H3.33m17.34-5.43H3.33m17.34-5.4h-4.34m4.34-5.42h-4.34M9.3 6.04H12c.3 0 .54.24.54.54v2.17c0 .3-.24.54-.54.54H9.83a.54.54 0 01-.54-.54v-2.7m.01-.01c0-2.17.4-2.53 1.62-3.25M3.33 6.04h2.71c.3 0 .54.24.54.54v2.17c0 .3-.24.54-.54.54H3.87a.54.54 0 01-.54-.54v-2.7m0-.01c0-2.17.4-2.53 1.63-3.25"
  })));
}
export default SvgBlockquote;